import { useCompanyContext } from '@/hooks/use-company-context';
import { useFleetGpsAccess } from '@/hooks/use-fleet-gps-access';
import { HardwareMarketplace } from '@/components/gps/HardwareMarketplace';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export default function Store() {
  const { companyId } = useCompanyContext();
  const { hasAccess, isLoading, reason } = useFleetGpsAccess(companyId);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <Alert className="max-w-2xl mx-auto mt-8">
        <Lock className="h-4 w-4" />
        <AlertTitle>Acesso Restrito - FleetONE Necessário</AlertTitle>
        <AlertDescription>
          {reason}
          <Button asChild className="ml-4" variant="default">
            <Link to="/admin/systems">Ativar FleetONE</Link>
          </Button>
        </AlertDescription>
      </Alert>
    );
  }

  return <HardwareMarketplace companyId={companyId} />;
}
